import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const [menuActive, setMenuState] = useState(false);
  const location = useLocation();

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // 현재 경로 확인 함수
  const isActive = (path) => {
    return location.pathname === path;
  };

  // 회사소개 하위 메뉴 확인 함수
  const isCompanyMenuActive = () => {
    return (
      location.pathname === "/company-intro" ||
      location.pathname === "/ceo-message" ||
      location.pathname === "/history"
    );
  };

  // 사업영역 하위 메뉴 확인 함수
  const isBusinessMenuActive = () => {
    return (
      location.pathname === "/business-area" ||
      location.pathname === "/research" ||
      location.pathname === "/patent"
    );
  };

  return (
    <header id="header">
      <div className={props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-6">
                <div
                  className="navbar-header"
                  style={{
                    display: "flex",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <Link onClick={ClickHandler} className="navbar-brand" to="/">
                    <img
                      src={props.Logo}
                      alt=""
                      style={{ width: "80px", opacity: 0.6 }}
                    />
                  </Link>{" "}
                  {window.innerWidth > 768 && (
                    <div
                      style={{
                        color: "#FFF",
                        fontWeight: "700",
                        fontSize: "23px",
                      }}
                    >
                      (주)엠알메탈로
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-7 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to="/company-intro"
                        className={`no-hover nav-link ${isCompanyMenuActive() ? "active" : ""}`}
                      >
                        <span>회사소개</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/company-intro") ? "active" : ""}`}
                            to="/company-intro"
                          >
                            엠알메탈로
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/ceo-message") ? "active" : ""}`}
                            to="/ceo-message"
                          >
                            인사말
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/history") ? "active" : ""}`}
                            to="/history"
                          >
                            연혁
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        to="/business-area"
                        className={`no-hover nav-link ${isBusinessMenuActive() ? "active" : ""}`}
                      >
                        <span>사업영역</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/business-area") ? "active" : ""}`}
                            to="/business-area"
                          >
                            사업영역
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/research") ? "active" : ""}`}
                            to="/research"
                          >
                            연구개발
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            className={`no-hover nav-link ${isActive("/patent") ? "active" : ""}`}
                            to="/patent"
                          >
                            특허ㆍ허가
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        className={`no-hover nav-link ${isActive("/board") ? "active" : ""}`}
                        to="/board"
                      >
                        게시판
                      </Link>
                    </li>
                    <li className="menu-item-has-children">
                      <Link
                        onClick={ClickHandler}
                        className={`no-hover nav-link ${isActive("/contact") ? "active" : ""}`}
                        to="/contact"
                      >
                        <span> Contact Us</span>
                        {/* <i className="ti-arrow-top-right"></i> */}
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        className={`no-hover nav-link ${isActive("/recruitment") ? "active" : ""}`}
                        to="/recruitment"
                      >
                        인재채용
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
